import { ChangeDetectionStrategy, Component, inject, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { CreateGameViewService } from '../../../application/view-services';
import { NgClass } from '@angular/common';
import { IonicModule } from '@ionic/angular';

@Component({
  selector: 'lib-game-type-modal',
  templateUrl: './game-type-modal.component.html',
  styleUrls: ['./game-type-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [IonicModule, NgClass]
})
export class GameTypeModalComponent {
  private readonly createGameViewService: CreateGameViewService = inject(CreateGameViewService);

  readonly isRecurring: Signal<boolean | undefined> = toSignal(this.createGameViewService.isRecurring$);

  constructor() {
    this.initializeRecurring();
  }

  private initializeRecurring(): void {
    this.createGameViewService.setIsRecurring(false);
  }

  setType(event: CustomEvent): void {
    this.createGameViewService.setIsRecurring(event.detail.value);
  }
}
